module.exports = __webpack_public_path__ + "media/images/banner/awards_mobile-31d020baac7d18872e056a4f0abd5fb5.jpg";